export default {"src":"/_next/static/media/house.0051fa16.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};